import * as R from 'ramda';
import {split} from 'lodash';

export const getTriggerName = (object: any) => {
  let name = R.pathOr('', ['attributes', 'name'], object);
  name = split(name, ' - ')[0]; // backwards compatibility
  return name;
};
